export const APPGUID = "E7DEB362-47CA-4B54-A730-4F8A260660FD";
export const AUTH = "Basic Mjo4OTJDOTQ3NC1BMzE2LTQ5OEEtOEFBQy04RTZEMDY1RThDRUM=";
export const TOKEN_KEY = "token";
export const USER_KEY = "user";
export const REMEMBER_ME_KEY = "remember";
export const ENVIRONMENT_MODES = {
  PRODUCTION: "PRODUCTION",
  DEVELOPMENT: "DEVELOPMENT",
  LOCAL: "LOCAL",
}
export const ENVIRONMENT_MODE = ENVIRONMENT_MODES.PRODUCTION;
export const API_TYPES = {
  ADMIN: "ADMIN",
  BASE: "BASE",
  WIDGET: "WIDGET",
  CRM: "CRM",
}
export const API_TYPE = API_TYPES.ADMIN;
export const SCOPES = {
  CREATE: "Create",
  EDIT: "Edit",
};
export const CONDITIONS = {
  NEW: "New",
  DEMO: "Demo",
  USED: "Used",
};
export const CAR_CONDITIONS = {
  EXCELLENT: "Excellent",
  GREAT: "Great",
  GOOD: "Good",
  FAIR: "Fair",
  POOR: "Poor"
};
export const DEAL_EDIT_ACTIONS = {
  TURN_ON: "Turn on",
  TURN_OFF: "Turn off",
  DUPLICATE: "Duplicate",
  EXTEND: "Extend",
};
export const DEAL_STATUSES = {
  ACTIVE: "Active",
  INACTIVE: "Inactive",
};
export const RATE_TYPES = {
  LINKED: "Linked",
  FIXED: "Fixed",
};
export const QUOTE_TYPES = {
  M: "M",
};
export const TRANSACTION_TYPES = {
  QUOTE: "QUOTE",
};
export const DEALERSHIP_NAMES = {
  CARTER_MITSUBISHI: "Carter Mitsubishi",
};
export const DEAL_TYPES = {
  INSTALMENT_PRICE: "InstalmentPrice",
  LIST_PRICE: "ListPrice",
};
export const FUEL_TYPES = {
  PETROL: "Petrol",
  DIESEL: "Diesel",
  HYBRID: "Hybrid",
};
export const TRANSMISSION_TYPES = {
  AUTO: "Auto",
  MANUAL: "Manual",
};
export const ACTIVE_DEAL_TYPES = {
  YES: "Yes",
  NO: "No",
};
export const COLOUR_TYPES = {
  WHITE: "White",
  SILVER: "Silver",
  RED: "Red",
  BLUE: "Blue",
  GREY: "Grey",
  BLACK: "Black",
  ORANGE: "Orange",
  TBA: "TBA",
};
export const DEAL_BY_BRAND_ID = {
  MITSUBISHI: 46,
  RENAULT: 52,
  SUZUKI: 57,
};
export const API_RESPONSE = {
  SUCCESS: "Success",
  ERROR: "Error",
  PRELOADEDDEAL_FOUND: "PreloadedDeal found. Update",
  PRELOADEDDEAL_NOT_FOUND: "No PreloadedDeal found. Insert",
  CARDATAPUBDEAL_FOUND: "CarDataPub deal found. Update",
  CARDATAPUBDEAL_NOT_FOUND: "No CarDataPub deal found. Insert",
};
export const IMAGES_ENDPOINT =
  ENVIRONMENT_MODE === ENVIRONMENT_MODES.PRODUCTION ? "https://images.heycarter.com/UsedCarImages"
    : ENVIRONMENT_MODE === ENVIRONMENT_MODES.DEVELOPMENT ? "https://devimages.heycarter.com/UsedCarImages"
      : "C:\\inetpub\\wwwroot\\car_images\\UsedCarImages";

export const APIS = {
  BASE: {
    PRODUCTION: "https://api.heycarter.com/api",
    DEVELOPMENT: "https://devapi.heycarter.com/api",
    LOCAL: "",
  },
  WIDGET: {
    PRODUCTION: "https://widgetapi.heycarter.co.za/api",
    DEVELOPMENT: "https://devwidgetapi.heycarter.co.za/api",
    LOCAL: "",
  },
  CRM: {
    PRODUCTION: "https://app.heycarter.com/CRMAPI",
    DEVELOPMENT: "https://devreact.heycarter.com/CRMAPI",
    LOCAL: "",
  },
  ADMIN: {
    PRODUCTION: "https://adminapiv2.heycarter.co.za/api",
    DEVELOPMENT: "https://devadminapiv2.heycarter.co.za/api",
    LOCAL: "https://localhost:44383/api",
  },
  AUTO_TRADER: {
    PRODUCTION: "https://services.autotrader.co.za/api",
    DEVELOPMENT: "https://services.autotrader.co.za/api",
    LOCAL: "https://services.autotrader.co.za/api",
  },
};

export const NEW_CARS_ALLOWED_USERS = [
  "marketing@heycarter.co.za",
  "lwandile.maja@heycarter.co.za",
  "shandelle.gordon@heycarter.co.za",
  "tristin.cunningham@heycarter.co.za"
]

export const USED_CARS_ALLOWED_USERS = [
  "tristin.cunningham@heycarter.co.za",
  "abigail.smith@heycarter.co.za",
]